import { render } from "./new-product-stepper-button.vue?vue&type=template&id=21cb4a48"
import script from "./new-product-stepper-button.vue?vue&type=script&lang=js"
export * from "./new-product-stepper-button.vue?vue&type=script&lang=js"
script.render = render

export default script